import { type ComponentProps, forwardRef } from "react";

import { cn } from "../lib/utils";

export interface TextareaProps extends ComponentProps<"textarea"> {
  defaultCursorToEnd?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, defaultCursorToEnd = true, ...props }, ref) => {
    return (
      <textarea
        data-slot="textarea"
        className={cn(
          "border-input placeholder:text-muted-foreground focus-visible:border-[#eeeeee] focus-visible:ring-[#eeeeee]/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-[10px] border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        {...props}
        ref={ref}
        onFocus={(e) => {
          if (defaultCursorToEnd && props.value && typeof props.value === "string") {
            e.target.setSelectionRange(props.value.length, props.value.length);
          }
          props.onFocus?.(e);
        }}
        style={{
          fieldSizing: "content",
        }}
      />
    );
  }
);
